import { render, staticRenderFns } from "./BoxedTemplate.vue?vue&type=template&id=166afe02&scoped=true&"
import script from "./BoxedTemplate.vue?vue&type=script&lang=js&"
export * from "./BoxedTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BoxedTemplate.vue?vue&type=style&index=0&id=166afe02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166afe02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBadge,VBtn,VIcon,VSpacer,VToolbarTitle})
